import { IAppState } from '../reducers';

export const selectSnackbarMessages = (state: IAppState) => state.snackbar.messages;
